const empathyDefinitions = {
    cognitive: "Cognitive empathy refers to the ability to understand another person's thoughts, perspective, and internal mental state. It's about intellectually grasping what someone else is going through.",
    affective: "Affective empathy refers to the ability to emotionally respond to another person’s emotional state. It's the capacity to feel what someone else is feeling on an emotional level.",
    empathicResponse: "Empathic Response refers to the ability to communicate and respond to others with empathy through actions, words, or expressions that show understanding and care."
};

export default empathyDefinitions;
